"use client";

import { useMaybeDomainStripping } from "@faire/web/ui/hooks/useMaybeDomainStripping";
import * as React from "react";
import styled from "styled-components";

import { shouldUseAnchorForLink } from "../lib";
import { Link, Anchor } from "../LinkAnchor";

import { EmbeddedLinkStyles } from "./styles";
import { EmbeddedLinkProps } from "./types";

const StyledAnchor = styled(Anchor)`
  ${EmbeddedLinkStyles}
`;

const StyledLink = styled(Link)`
  ${EmbeddedLinkStyles}
`;

/**
 * @deprecated use slate-deprecated/Button tertiary variant instead
 */
export const EmbeddedLink = (props: EmbeddedLinkProps) => {
  const { linkTo, children, onClick, ...rest } = props;
  const { potentiallyRelativeLink = linkTo } = useMaybeDomainStripping(
    linkTo,
    rest.target
  );

  if (shouldUseAnchorForLink(potentiallyRelativeLink)) {
    return (
      <StyledAnchor {...rest} href={potentiallyRelativeLink} onClick={onClick}>
        {children}
      </StyledAnchor>
    );
  }

  if (!potentiallyRelativeLink) {
    return (
      <StyledAnchor {...rest} onClick={onClick} role="button">
        {children}
      </StyledAnchor>
    );
  } else {
    return (
      <StyledLink {...rest} to={potentiallyRelativeLink} onClick={onClick}>
        {children}
      </StyledLink>
    );
  }
};
